import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const SenderDropdown = ({
    helperText,
    error,
    setFormValues,
    isFilter,
    selectedSender,
    setSelectedSender,
}) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const handleString = (str) => {
        if (str === t("driver")) return "driver";
        else if (str === t("user")) return "user";
    };

    const options = [t("driver"), t("user")];

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={options}
                getOptionLabel={(option) => option}
                value={selectedSender || ""}
                onChange={(event, newValue) => {
                    setSelectedSender(newValue);
                    setFormValues &&
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            sender: handleString(newValue) || null,
                        }));
                }}
                renderInput={(params) => (
                    <Box>
                        {!isFilter && (
                            <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("sender")}
                            </p>
                        )}

                        <TextField
                            {...params}
                            variant={isFilter ? "standard" : "outlined"}
                            fullWidth
                            placeholder={isFilter ? t("sender") : t("chooseSender")}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter
                                        ? "transparent"
                                        : theme.palette.customGrey.insideInput,
                                    padding: "6px 8px",
                                },
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor:
                                            theme.palette.customGrey.borderInput,
                                    },
                                    "&:hover fieldset": {
                                        borderColor:
                                            theme.palette.customGrey.borderInput,
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: theme.palette.text.primary,
                                    padding: "6px 8px",
                                    "&::placeholder": {
                                        fontSize: "14px",
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
};

export default SenderDropdown;
